import ajax from '../../lib/ajax'
export async function QueryUnit(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/QueryUnit',payload,false)
    return res.data.result
}
export async function CreateUnit(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/CreateUnit',payload)
    return res.data.result
}
export async function EditUnit(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/EditUnit',payload)
    return res.data.result
}
export async function QueryManufacturer(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/QueryManufacturer',payload,false)
    return res.data.result
}
export async function CreateManufacturer(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/CreateManufacturer',payload)
    return res.data.result
}
export async function EditManufacturer(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/EditManufacturer',payload)
    return res.data.result
}
export async function QuerySupplier(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/QuerySupplier',payload,false)
    return res.data.result
}
export async function CreateSupplier(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/CreateSupplier',payload)
    return res.data.result
}
export async function EditSupplier(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/EditSupplier',payload)
    return res.data.result
}
export async function ManufacturerSyn(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/ManufacturerSyn',payload)
    return res.data.result
}